<template>
    <div>

        <PageHeader side-class="flex-shrink-0">
            <div class="d-flex gap-3 align-items-center">
                <div>{{ node.label }}</div>
                <ButtonIcon size="sm" :disabled="!product.id" @click="showModalEditProduct()">{{ $t('edit') }}</ButtonIcon>
            </div>
            <template #side>
                <div class="d-flex gap-3">
                    <ButtonIcon icon="plus" :disabled="!product.id" @click="showModalAddProductToGroup()">{{ $t('addToGroup') }}</ButtonIcon>
                </div>
            </template>
        </PageHeader>

        <div class="mb-3">
            <div class="d-flex gap-1 align-items-center">
                <strong>GTIN:</strong>
                <b-skeleton v-if="requestProduct.getLoading()" animation="wave" width="150px" />
                <template v-else>{{ product.ean }}</template>
            </div>
            <div class="d-flex gap-1 align-items-center">
                <strong>SKU:</strong>
                <b-skeleton v-if="requestProduct.getLoading()" animation="wave" width="150px" />
                <template v-else>{{ product.sku }}</template>
            </div>
            <div class="d-flex gap-1 align-items-center">
                <strong>{{ $t('catalogPrice') }}:</strong>
                <b-skeleton v-if="requestProduct.getLoading()" animation="wave" width="150px" />
                <template v-else>
                    <template v-if="product.price">{{ $format.currency(product.price) }}</template>
                    <template v-else>{{ $t('noDefinedPrice').toUpperCase() }}</template>
                </template>
            </div>
            <div>
                <ButtonIcon icon="chevron-right" flip-icon variant="link" class="p-0" href="#anchor-product-landing-page">{{ $t('productLandingPage2') }}</ButtonIcon>
            </div>
        </div>

        <StatsWidgets />

        <TrafficChart />

        <SalesChart />

        <AvailabilityChart />

        <PriceChart />

        <OfferList />

        <ProductCode />

        <ProductLandingPage id="anchor-product-landing-page" />

        <ModalAddItemToGroup />

    </div>
</template>



<script>
    import StatsWidgets from './StatsWidgets.vue';
    import TrafficChart from './TrafficChart.vue';
    import SalesChart from './SalesChart.vue';
    import AvailabilityChart from './AvailabilityChart.vue';
    import PriceChart from './PriceChart.vue';
    import OfferList from './OfferList.vue';
    import ProductCode from './ProductCode.vue';
    import ProductLandingPage from './ProductLandingPage.vue';
    import ModalAddItemToGroup from './ModalAddItemToGroup.vue';

    export default {
        name: 'ProductStats',
        components: {
            StatsWidgets,
            TrafficChart,
            SalesChart,
            AvailabilityChart,
            PriceChart,
            OfferList,
            ProductCode,
            ProductLandingPage,
            ModalAddItemToGroup,
        },
        props: {
            node: {
                type: Object,
                required: true,
            },
        },
        inject: {
            parentComponent: {
                default: null,
            },
        },
        provide() {
            return {
                parentComponent: this,
            };
        },
        data() {
            return {
                requestProduct: this.$req('producerProduct/product'),
                requestSalesStats: this.$req('producerProduct/salesStats'),
                requestClicksStats: this.$req('producerProduct/clicksStats'),
                requestImpressionsStats: this.$req('producerProduct/impressionsStats'),
                requestTrafficChart: this.$req('producerProduct/trafficChart'),
                requestSalesChart: this.$req('producerProduct/salesChart'),
                requestAvailabilityChart: this.$req('producerProduct/availabilityChart'),
                requestPriceChart: this.$req('producerProduct/priceChart'),
                requestPlugin: this.$req('plugin/producerPlugin'),
            };
        },
        computed: {
            item() {
                return this.parentComponent.item;
            },
            timeRange() {
                return this.parentComponent.timeRange;
            },
            product() {
                return this.requestProduct.getData() || {};
            },
            spaceId() {
                return this.parentComponent.spaceId;
            },
        },
        watch: {
            node: {
                immediate: true,
                handler: 'fetchProduct',
            },
            spaceId: {
                immediate: true,
                handler: 'fetchPlugin',
            },
        },
        methods: {
            fetchProduct() {
                this.requestProduct.reset();
                this.requestProduct.get({ urlParams: { id: this.node.id } });
            },
            fetchPlugin() {
                this.requestPlugin.reset();
                this.requestPlugin.get(this.spaceId);
            },
            showModalEditProduct() {
                this.$root.$emit('bv::show::modal', 'modal-form-space-producer-product');
                this.$root.$emit('modal-form-space-producer-product', this.node);
            },
            showModalAddProductToGroup() {
                this.$root.$emit('bv::show::modal', 'modal-add-item-to-group');
                this.$root.$emit('modal-add-item-to-group', this.node);
            },
        },
    };
</script>
